export default "__VITE_ASSET__c6efcc00__"